import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './_magic-view.scss';
import ComputerOnTable from 'assets/images/computer-on-table.png';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { Projects } from 'components';

const MagicView = ({ showMenu }) => {
  const [showProjects, setShowProjects] = useState(false);

  return (
    <>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={showProjects}
          timeout={{ enter: 2000, exit: 1000 }}
          classNames="fade-two"
          mountOnEnter
          unmountOnExit
        >
          {!showProjects ? (
            <div
              className={`relative flex flex-col lg:flex-row lg:justify-between flex-grow shrink min-w-0 magic__view overflow-y-auto lg:overflow-visible ${
                showMenu ? 'active' : ''
              }`}
            >
              <div className="relative z-10 flex flex-col justify-center min-w-0 px-6 sm:px-10 lg:pl-32 pt-24 pb-[320px] lg:pb-0 lg:pt-0 lg:basis-4/6">
                <h1 className="text-[15px] md:text-[18px] mb-4 lg:mb-12">Hi, I'm Dayo Ashaolu</h1>
                <h2
                  className="fw-600 text-[34px] sm:text-[46px] md:text-[56px] lg:text-[70px] leading-tight lg:leading-[85px] mb-4"
                  style={{ color: '#10111F' }}
                >
                  Front End Developer
                </h2>
                <p className="mb-4 w-full lg:w-3/5">
                  A motivated front-end developer passionate about blending the art of design and programming to deliver
                  an immersive and engaging user experience.
                </p>
                <button onClick={() => setShowProjects(!showProjects)} className="btn btn--primary">
                  View Projects
                </button>
              </div>
              <div className="shrink-0 absolute inset-x-0 bottom-0 h-[300px] overflow-hidden rounded-t-[32px] lg:rounded-none lg:static lg:inset-auto lg:h-full lg:w-[45%] xl:w-[580px]">
                <img
                  src={ComputerOnTable}
                  width={966}
                  height={1537}
                  className="absolute top-1/2 left-1/2 w-[300px] h-[100vw] max-w-none -translate-x-1/2 -translate-y-1/2 rotate-90 object-cover object-[center_30%] lg:static lg:top-auto lg:left-auto lg:w-full lg:h-full lg:max-w-full lg:translate-x-0 lg:translate-y-0 lg:rotate-0 lg:object-fill"
                  alt="computer-on-table"
                />
                <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-[#F6F6F8] via-[#F6F6F8]/70 to-transparent pointer-events-none lg:hidden" />
              </div>
            </div>
          ) : (
            <div className={`flex-grow shrink min-w-0 magic__view ${showMenu ? 'active' : ''}`}>
              <Projects />
            </div>
          )}
        </CSSTransition>
      </SwitchTransition>
    </>
  );
};

MagicView.propTypes = {
  showMenu: PropTypes.bool,
};

export default MagicView;
